// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2QBOp","label":"Section_label__Vl_YT","contentWrap":"Section_contentWrap__ztQaD","footer":"Section_footer__3v7Ii","footerInner":"Section_footerInner__lNtyZ"};